import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AuthService } from '../../_core';

@Component({
  selector: 'app-layout-default',
  templateUrl: './layout-default.component.html',
  styleUrls: ['./layout-default.component.scss'],
  providers: [AuthService]
})
export class LayoutDefaultComponent implements OnInit, AfterViewInit, OnChanges {

  @Input('fields') fieldsIn: any
  @Input('contentClass') contentClass: string

  @ViewChild('bottomContainer') bottomContainer: ElementRef
  @Output() containers = new EventEmitter<any>()
  // @Input('bannerSrc') bannerSrc: any
  // @Input('title') title: any

  populated$: any
  isPopulated: any

  fields: any = {}
  fieldsDefault = {
    // banner_src: 'https://res.cloudinary.com/oak-park-wedding-gown-cleaners/image/upload/v1710291303/banner-dress-bottom_bsdrmg.webp',
    // banner_id: 'banner-dress-bottom_bsdrmg',
    banner_ar: 2
  }
  // fieldsDefault = {
  //   // banner_src: 'https://...'.
  //   // banner_text: 'Revitalize your wedding gown',
  //   // banner_button_text: 'Request a Quote',
  //   // banner_button_path: '/request-quote',
  // }


  constructor(
    private authService: AuthService,
    private cdr: ChangeDetectorRef
  ){}

  ngOnInit(): void {
    // console.log('init', this.bannerSrc, this.title, this.fields)
    // console.log('init', this.fields)

    this.populated$ = this.isPopulatedStream()
    this.update()
  }

  ngAfterViewInit() {
    let containers = { bottom: this.bottomContainer }
    this.containers.emit(containers)
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.update()
  }
  
  update() {
    this.fields = Object.assign({}, this.fieldsDefault, this.fieldsIn)
    // console.log('fields', this.fields)
  }

  isPopulatedStream() {
    return this.authService.isPopulated.subscribe(isPopulated => {
      // console.log('pop')
      this.isPopulated = isPopulated
      this.detectChanges()
    })
  }

  detectChanges() {
    if (!this.cdr['destroyed']) this.cdr.detectChanges()
  }
}